<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break" id="auto_bookmark_toc_1"><span>To my husband, as promised.</span></p>
<p class="p_norm-center__and__page_break"><span>To my mom, for always being there for me.</span></p>
<p class="p_norm-center__and__page_break"><span>To Betty, whose unflagging support keeps making this possible.</span></p>
<p class="p_norm-center__and__page_break"><span>And to my daughters, for patiently waiting for the next dedication.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?0abbe312